/**
 * Analytics cookie consent helpers.
 * Consent is stored in localStorage and applied to GA4 via the
 * `ga-disable-<MEASUREMENT_ID>` flag plus gtag consent updates.
 */

const KEY = "bz-cookie-consent";
export const GA_MEASUREMENT_ID = "G-F8VY2DR702";

export function getConsent() {
  try {
    return localStorage.getItem(KEY); // "accepted" | "declined" | null
  } catch (_) {
    return null;
  }
}

export function applyConsent(value) {
  if (typeof window === "undefined") return;
  const declined = value === "declined";
  window[`ga-disable-${GA_MEASUREMENT_ID}`] = declined;
  try {
    if (typeof window.gtag === "function") {
      window.gtag("consent", "update", {
        analytics_storage: declined ? "denied" : "granted",
      });
    }
  } catch (_) {
    // no-op
  }
  // Clarity only ever loads after an explicit accept (see index.html)
  if (value === "accepted" && typeof window.__loadClarity === "function") {
    try { window.__loadClarity(); } catch (_) { /* no-op */ }
  }
}

export function setConsent(value) {
  try {
    localStorage.setItem(KEY, value);
  } catch (_) {
    // no-op
  }
  applyConsent(value);
}

export function analyticsAllowed() {
  return getConsent() !== "declined";
}
